import gsap, { Power2 as Ease } from 'gsap'

class Modal {
  constructor(trigger, target) {
    this.trigger = trigger
    this.target = target
    this.container = this.target.children[0]
    this.isOpen = false

    this.closeButtons = this.target.querySelectorAll('.js-world-modal-close')
    this.trigger.addEventListener('click', (e) => {
      e.preventDefault()
      this.open()
    })
    this.target.addEventListener('click', this.close.bind(this))
    if (this.container) {
      this.container.addEventListener('click', (e) => {
        e.stopPropagation()
      })
    }
    this.closeButtons.forEach((button) => {
      button.addEventListener('click', this.close.bind(this))
    })
  }
  close() {
    this.isOpen = false

    this.target.classList.remove('is-open')
    gsap.to(this.target, 0.5, {
      opacity: 0,
      ease: Ease.easeOut,
      onComplete: () => {
        this.target.style.display = 'none'
        document.documentElement.classList.remove('is-fixed')
      },
    })
  }
  open() {
    this.isOpen = true
    document.documentElement.classList.add('is-fixed')
    this.target.classList.add('is-open')
    this.target.style.display = 'flex'
    gsap.to(this.target, 0.5, {
      ease: Ease.easeOut,
      opacity: 1,
    })
  }
}

export class WorldModals {
  constructor() {
    this.triggers = [...document.getElementsByClassName('js-world-modal')]
    if (this.triggers.length === 0) return
    const page = document.getElementById('page')
    console.log(page)
    this.modals = this.triggers
      .map((trigger) => {
        const href = trigger.getAttribute('href')
        if (!href) return null
        const target = document.getElementById(href.replace(/#/, ''))
        if (!target) return null
        if (page) {
          page.appendChild(target)
        }
        return new Modal(trigger, target)
      })
      .filter((t) => t)
  }
}
